import React, { useState } from "react";
import styles from './partList.module.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box, Button,
  Divider, Grid,

} from "@mui/material";
import { Delete, Payment } from "../../../Svg";
import { styled } from '@mui/material/styles';
import { fomateDate } from "../../../utils/fomateDate";




const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));




const EnquiryList = ({ data, deleteProductFromenq, status, from }) => {




  console.log(data);



  return (
    <>
      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" alignItems="center" >
          <Payment />
          <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
            Product
          </Typography>
          <Typography style={{ marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", background: "#EAFFFE", color: '#006C64' }}>
            {data?.length} Products
          </Typography>
        </Box>
        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}> Part #</th>
                <th className={styles.previewth}>Manufacture</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Required Quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Required date</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>{from == "excess" ? "Target Price" : "Required price"}</th>
                {from != "excess" &&
                  <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Master price</th>
                }
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}></th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{index + 1}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.productNumber}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.manufacturer}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.quantity}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{fomateDate(item?.requiredDate)}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{from == "excess" ? item?.targetPrice : ''}</td>
                  {from != "excess" &&
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}></td>
}
                  <td className={styles.previewtd}>
                    {status != 'COMPLETED' && deleteProductFromenq && (
                      <div className={styles.closetd} onClick={() => deleteProductFromenq(item?._id)} style={{ cursor: 'pointer' }}>
                        <Delete />
                      </div>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>



        </div>
      </Paper>
      {/* <Paper sx={{ padding: '20px 30px', mt: 2, boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
        <Box display="flex" justifyContent="space-between" alignItems='center' fontWeight="bold" >
          <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 600 }}>Grand Total: $590.00</Typography>
          <ActionButton sx={{ background: '#512DA8', color: '#fff' }}>Approve & submit</ActionButton>
        </Box>
      </Paper> */}
    </>
  );
};

export default EnquiryList;
